import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { useStyles } from './no-fittings.styles';
import glassesIcon from '../../../../../assets/images/ecp/no-fitting-glasses.svg';

export const NoFittings = (): JSX.Element | null => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <div
      className={classes.content}
      data-testid="no-fittings-wrapper"
    >
      <img src={glassesIcon} alt="" width={48} height={48} data-testid="no-fittings-image" />
      <p className={classes.text} data-testid="no-fittings-text">{intl.formatMessage(
        { id: 'ecp.noFittings' },
        { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
      )}</p>
    </div>
  );
};
